import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import InstagramIcon from "../../assets/svg/InstagramIcon";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <img src="/logo-key.png" width={35} height={35} alt="Chave" />
          <h1 className="whiteColor font20" style={{ marginLeft: "10px" }}>
            Chaveiro 24hrs
          </h1>
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font16 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
            rel="nofollow"
          >
            Início
          </Link>
        </li>
        <li className="semiBold font16 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="brands"
            spy={true}
            smooth={true}
            offset={-60}
            rel="nofollow"
          >
            Marcas
          </Link>
        </li>
        <li className="semiBold font16 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="products"
            spy={true}
            smooth={true}
            offset={-60}
            rel="nofollow"
          >
            Produtos
          </Link>
        </li>
        <li className="semiBold font16 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="location"
            spy={true}
            smooth={true}
            offset={-150}
            rel="nofollow"
          >
            Localização
          </Link>
        </li>
        <li className="semiBold font16 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="testimonial"
            spy={true}
            smooth={true}
            offset={-120}
            rel="nofollow"
          >
            Avaliações
          </Link>
        </li>
        <ListInstagram>
          <AnchorInstagram href="https://www.instagram.com/chaveiro.24hcentro/" target="_blank" rel="noreferrer">
            <InstagramIcon />
            <p className="font13 whiteColor">
              @chaveiro.24hcentro
            </p>
          </AnchorInstagram>
        </ListInstagram>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
const AnchorInstagram = styled.a`
  display: flex;
  align-items: center;
  text-decoration: unset;
  gap: 3px;
  @media (max-width: 550px) {
    margin: 5px 0;
  }
`;
const ListInstagram = styled.li`
  margin: 20px 0;
  font-weight: 400;
  padding: 2px 30px;
`;
